import { Component, Input } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-modal-title',
  standalone: true,
  imports: [NzIconModule],
  template: `
    <div class="flex items-center gap-2">
      <span nz-icon [nzType]="icon" nzTheme="outline"></span>
      <span>{{ title }}</span>
    </div>
  `,
})
export class ModalTitle {
  @Input({ required: true }) icon = '';
  @Input({ required: true }) title = '';
}
